import { rem, rgba } from "polished"

const infobox = {
  color: ({ theme }) => theme.colors.firefly,
  backgroundColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => rgba(theme.colors.firefly, 0.2),
  iconColor: ({ theme }) => theme.colors.firefly,
  br: rem(5),
}

export default infobox
